import { createAction, createAsyncAction } from 'typesafe-actions';
import { BasketItem, BasketItemFlow, ViewsModels } from '../types';

/**
 * Do not use `BASKET_` actions outside of `feature` dir.
 * Use BasketFlowActions with GA handler included
 */
export const BASKET_UPDATE_ITEM = createAction('basket/BASKET_UPDATE_ITEM')<BasketItem>();
export const BASKET_SET = createAction('basket/BASKET_SET')<BasketItem[]>();

export const FETCH_MEASUREMENT_SETTINGS = createAsyncAction(
  'basket/FETCH_MEASUREMENT_SETTINGS/request',
  'basket/FETCH_MEASUREMENT_SETTINGS/success',
  'basket/FETCH_MEASUREMENT_SETTINGS/failure',
  'basket/FETCH_MEASUREMENT_SETTINGS/cancel',
)<void, ViewsModels.MeasurementSettings | null, Error, void>();

/**
 * Actions for usage in other features
 */
export namespace BasketFlowActions {
  /**
   * @description Prefix can be used for intercepting all events from namespace,
   * e.g. action.type.startsWith(BasketFlowActions.PREFIX)
   */
  export const PREFIX = 'basket/flow';

  export type UpdateItemPayload = BasketItemFlow & { isNeedGA?: boolean };
  export const UPDATE_ITEM = createAction(`${PREFIX}/UPDATE_ITEM`)<UpdateItemPayload>();

  export type ResetItemPayload = Omit<BasketItemFlow, 'flowQty'>;
  export const RESET_ITEM = createAction(`${PREFIX}/RESET_ITEM`)<ResetItemPayload>();

  export type BasketUpdatePayload = BasketItem[];
  export const LOAD = createAction(`${PREFIX}/LOAD`)();
  export const UPDATE = createAction(`${PREFIX}/UPDATE`)<BasketUpdatePayload>();
}

export type UpdateTintServiceInBasketPayload = {
  parentLineId: string;
  flowQty: number;
  hex: string;
  color: string;
  serviceIdForTint: string;
  currentServiceQuantity: number;
};

export const UPDATE_TINT_SERVICE_IN_SERVICE_BASKET = createAction(
  'service_basket/UPDATE_TINT_SERVICE_IN_SERVICE_BASKET',
)<UpdateTintServiceInBasketPayload>();
